import {AlertState} from "./types";

const initialState : AlertState = {
    transactionId: '-1',
    events: [],
    sorting: {
        type:'prio',
        direction: 1
    },
    alarmScenarioList: [],
    selectedEvent: null,
    currentCamera: null,
    playSound: null,
    pollingEvents: false,
    initialLoad: true
};

export default initialState